import React from "react";
import { roleLabel, roleClass } from "../roles";

const ROLE_ORDER = {
  don: 0,
  mafia: 1,
  maniac: 2,
  sheriff: 3,
  sergeant: 4,
  doctor: 5,
  civilian: 6,
};

export default function PlayerBoard({
  players,
  onKick,
  busyPlayerId,
  // Режим вибору гравця для форми дії: коли pickField не null, картки
  // гравців стають тапабельними — тап підставляє гравця як актора/ціль
  // замість випадаючого списку.
  pickField = null,
  pickCandidateIds = null,
  selectedActorId = null,
  selectedTargetId = null,
  onPickPlayer = null,
  // Режим перегляду історії: без кнопки "Вигнати" і без тапабельного вибору,
  // лише статичний список гравців та їхніх ролей.
  readOnly = false,
}) {
  const sortedPlayers = [...players].sort((a, b) => {
    const aOrder = ROLE_ORDER[a.role] ?? 999;
    const bOrder = ROLE_ORDER[b.role] ?? 999;

    if (aOrder !== bOrder) return aOrder - bOrder;
    return String(a.name || "").localeCompare(String(b.name || ""), "uk");
  });

  const picking = !readOnly && Boolean(pickField && onPickPlayer);

  return (
    <ul className={`player-board ${picking ? "player-board-picking" : ""}`}>
      {sortedPlayers.map((p) => {
        const isCandidate = picking && (!pickCandidateIds || pickCandidateIds.has(String(p.id)));
        const isSelectedActor = selectedActorId && String(selectedActorId) === String(p.id);
        const isSelectedTarget = selectedTargetId && String(selectedTargetId) === String(p.id);

        function handleCardClick() {
          if (picking && isCandidate) onPickPlayer(p.id);
        }

        return (
          <li
            key={p.id}
            className={`player-card ${p.alive ? "" : "player-card-out"} ${
              picking && isCandidate ? "player-card-pickable" : ""
            } ${picking && !isCandidate ? "player-card-dimmed" : ""} ${
              isSelectedActor ? "player-card-selected-actor" : ""
            } ${isSelectedTarget ? "player-card-selected-target" : ""}`}
            onClick={picking && isCandidate ? handleCardClick : undefined}
            role={picking && isCandidate ? "button" : undefined}
            tabIndex={picking && isCandidate ? 0 : undefined}
            onKeyDown={
              picking && isCandidate
                ? (e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleCardClick();
                    }
                  }
                : undefined
            }
          >
            <div className="player-card-main">
              <span className="player-card-name">
                {p.name}
                {isSelectedActor && <span className="player-card-tag"> · виконавець</span>}
                {isSelectedTarget && <span className="player-card-tag"> · ціль</span>}
              </span>
              <span className={`player-card-role ${roleClass(p.role)}`}>{roleLabel(p.role)}</span>
            </div>
            {readOnly ? (
              <span className="player-out-badge">{p.alive ? "дожив до кінця" : "поза грою"}</span>
            ) : p.alive ? (
              <button
                className="btn btn-ghost btn-small"
                disabled={busyPlayerId === p.id}
                onClick={(e) => {
                  e.stopPropagation();
                  onKick(p);
                }}
              >
                {busyPlayerId === p.id ? "…" : "Вигнати"}
              </button>
            ) : (
              <span className="player-out-badge">поза грою</span>
            )}
          </li>
        );
      })}
    </ul>
  );
}
